<div class="space-y-3 p-4">

    <div class="flex items-center gap-2 text-sm text-gray-100 dark:text-gray-100">
        <svg class="w-4 h-4 animate-spin" viewBox="0 0 24 24" fill="none">
            <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
            <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"></path>
        </svg>
        <span>{{ label }}...</span>
    </div>

    <div class="animate-pulse space-y-3">
        <div class="h-4 bg-gray-300 dark:bg-gray-700 rounded w-1/3"></div>
        <div class="h-4 bg-gray-300 dark:bg-gray-700 rounded w-full"></div>
        <div class="h-4 bg-gray-300 dark:bg-gray-700 rounded w-5/6"></div>
        <div class="h-32 bg-gray-300 dark:bg-gray-700 rounded"></div>
    </div>

</div>